import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import {
  beforeSaveBank,
  personRenderMethods,
  schema_adresse,
  schema_bank,
  schema_buwbv,
  schema_stamm,
  schema_werkvertrag,
} from "Apis/person-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab from "App/shk-form-tab";
import {
  ASTMODUSKEY,
  ROLLEN,
} from "App/constants";
import {
  getModus,
} from "App/antragsteller-modus";

export const subpanels = [
  {
    key: "stamm",
    header: "Angaben zur Person",
    schema: schema_stamm,
    endpoint: `/api/shkperson/person`,
  },
  {
    key: "buwbv",
    header: "Angaben zu Beschäftigung bei BUW / öffentlichem Dienst",
    schema: schema_buwbv,
    endpoint: `/api/shkperson/person`,
    renderMethods: personRenderMethods,
  },

  {
    key: "adresse",
    header: "Kontaktdaten",
    schema: schema_adresse,
    endpoint: `/api/shkperson/person`,
  },
  {
    key: "bank",
    header: "Bankverbindung",
    schema: schema_bank,
    endpoint: `/api/shkperson/person`,
    validateEdits: (entity, edits) => {
      if (edits.p_iban) {
        edits.p_iban = edits.p_iban.toUpperCase();
      }
    },
    beforeSave: beforeSaveBank,
  },
  {
    key: "werkvertrag",
    header: "Angaben zu Werkverträgen",
    schema: schema_werkvertrag,
    endpoint: `/api/shkperson/person`,
  },

];

const injects = _.flatMap(subpanels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

_.map(subpanels, panel => _.assign(panel, { route: "/person/stamm", label: "Persönliche Daten" }));

@store(...injects, "user", "flag_antragstellermodus", "k_beschaeftigtLookup")
export default class PersonStammTab extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    getModus(this.props);
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus) {
      await getModus(this.props);
    }
  }

  render() {
    const { user, flag_antragstellermodus } = this.props;

    if (!flag_antragstellermodus) {
      /*
       * Wenn Modus noch nicht bekannt ist, SHKForm nicht rendern, weil eine geladene Instanz
       * ihre Panels und die abhängigen Dinge cached und nicht on the fly ändern möchte
       */
      return null;
    }

    if (user && user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER) {
      const personPanel = subpanels.find(p => p.key == "stamm");
      // Für Antragsteller Personalnummer aus der Ansicht entfernen
      personPanel.schema.table = _.filter(personPanel.schema.table, f => f.field != "p_svakey");
    }
    if (flag_antragstellermodus == ASTMODUSKEY.Tarif) {
      const personPanel = subpanels.find(p => p.key == "adresse");
      // Für Tarif die Telefonnr. zwingend machen.
      const tel = personPanel.schema.table.find(f => f.field === "p_tel");
      tel.required = true;
    } else {
      const personPanel = subpanels.find(p => p.key == "adresse");
      // Für Tarif die Telefonnr. zwingend machen.
      const tel = personPanel.schema.table.find(f => f.field === "p_tel");
      tel.required = false;
    }
    {
      const personPanel = subpanels.find(p => p.key == "adresse");
      const land = personPanel.schema.table.find(f => f.field === "p_land_ksaid");
      land.required = flag_antragstellermodus == ASTMODUSKEY.Lehrauftrag || flag_antragstellermodus == ASTMODUSKEY.Vortrag;
    }

    let mypanels = [];
    // Rollen, die keine Kontaktdaten und Bankverbindung sehen dürfen
    const rollenOhneKontaktdaten = [
      ROLLEN.ROLLE_PERSONALRAT_TUV,
      ROLLEN.ROLLE_PERSONALRAT,
      ROLLEN.ROLLE_GLEICHSTELLUNG,
      ROLLEN.ROLLE_SBV,
    ];
    const istRolleOhneKontaktdaten = user && rollenOhneKontaktdaten.includes(user.ro_id);

    if (flag_antragstellermodus != ASTMODUSKEY.WerkPrivat) {
      mypanels = _.cloneDeep(subpanels).filter(item => item.key != "buwbv" && item.key != "werkvertrag");
    } else {
      // Werkvertrag inkl. BUW-BV Subpanel
      mypanels = _.cloneDeep(subpanels);
    }

    // Kontaktdaten und Bankverbindung für bestimmte Rollen ausblenden
    if (istRolleOhneKontaktdaten) {
      mypanels = mypanels.filter(item => item.key != "adresse" && item.key != "bank");
    }

    return <SHKFormTab
      subpanels={mypanels}
      injects={selectInjects(this.props)}
    />;
  }
}
